import { 
  SET_AUTO_PAY_ENABLED, 
  SET_CONFIRMATION_MODAL_OPEN, 
  SET_CONFIRMATION_MODAL_PLAN, 
  SET_KEEP_SHOPPING_NAVIGATION_DATA,
  ADD_PLAN,
  ADD_PLAN_SUCCESS,
  ADD_PLAN_FAILURE,
  ADD_PLAN_ID_TO_ADDED_LIST,
  ADD_BACKUP_PLAN_ID_TO_ADDED_LIST,
  ADD_BACKUP_PLAN,
  ADD_BACKUP_PLAN_SUCCESS,
  ADD_BACKUP_PLAN_FAILURE,
  SET_ADDED_POPULAR_PLAN_ID,
  SET_REMOVE_LINE_SUCCESS_UPDATE_CART_FAILED,
  SET_BACKUP_MLP_AUTO_EXPANDED,
} from './actionTypes';
import { isAnyJointTransactionFlow, isLoggedIn } from '../../../../components/common/Helpers';
import * as actionTypes from '../actionTypes';

const initialState = {
  isAutoPayEnabled: false,
  confirmationModalOpen: false,
  confirmationModalPlan: null,
  keepShoppingNavigationData: { processStep: '', history: null },
  addPlanLoading: false,
  addPlanApiResponse: null,
  addPlanError: null,
  currentPlanInCart: null,
  addBackupPlanLoading: false,
  addBackupPlanApiResponse: null,
  addBackupPlanError: null,
  backupPlanInCart: null,
  addedPopularPlanId: null,
  lastAddedPopularChoiceOffer: null,
  removeLineSuccessUpdateCartFailed: false,
  // Whether the Wi-Fi Backup MLP auto-expand has already run. Lives in the store so it lasts for
  // the page load, covering in-app returns to the plans page but resetting on a refresh.
  backupMlpAutoExpanded: false,
};

const progressivePlansRedesignReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PROGRESSIVE_PLANS_SUCCESS:
      return {
        ...state,
        isAutoPayEnabled: isLoggedIn() ? action.response?.data?.autoPayEnrolled || false : true,
      };
    case SET_AUTO_PAY_ENABLED:
      return {
        ...state,
        isAutoPayEnabled: action.payload,
      };
    case SET_CONFIRMATION_MODAL_OPEN:
      return {
        ...state,
        // Joint transaction flows continue through the joint cart, so the
        // "Added to your cart" confirmation modal is never shown for them.
        confirmationModalOpen: isAnyJointTransactionFlow() ? false : action.payload,
      };
    case SET_CONFIRMATION_MODAL_PLAN:
      return {
        ...state,
        confirmationModalPlan: action.payload,
      };
    case SET_KEEP_SHOPPING_NAVIGATION_DATA:
      return {
        ...state,
        keepShoppingNavigationData: action.payload,
      };
    case ADD_PLAN:
      return {
        ...state,
        addPlanLoading: true,
        addPlanApiResponse: null,
        addPlanError: null,
      };
    case ADD_PLAN_SUCCESS:
      return {
        ...state,
        addPlanLoading: false,
        addPlanApiResponse: action.response,
        addPlanError: null,
        currentPlanInCart: action.planId || state.currentPlanInCart,
        removeLineSuccessUpdateCartFailed: false,
      };
    case ADD_PLAN_FAILURE:
      return {
        ...state,
        addPlanLoading: false,
        addPlanApiResponse: action.response,
        addPlanError: action.error,
      };
    case ADD_PLAN_ID_TO_ADDED_LIST:
      // Allow null to clear the value (sync with cart contents)
      return {
        ...state,
        currentPlanInCart: action.planId !== undefined ? action.planId : state.currentPlanInCart,
      };
    case SET_ADDED_POPULAR_PLAN_ID:
      return {
        ...state,
        addedPopularPlanId: action.planId !== undefined ? action.planId : state.addedPopularPlanId,
        lastAddedPopularChoiceOffer: action.choiceOffer !== undefined
          ? (action.choiceOffer || null)
          : state.lastAddedPopularChoiceOffer,
      };
    case ADD_BACKUP_PLAN_ID_TO_ADDED_LIST:
      // Allow null to clear the value (sync with cart contents)
      return {
        ...state,
        backupPlanInCart: action.planId !== undefined ? action.planId : state.backupPlanInCart,
      };
    // Wi-Fi Backup is tracked on its own keys. It must never touch currentPlanInCart,
    // which drives the "Added" state of the primary plan tiles.
    case ADD_BACKUP_PLAN:
      return {
        ...state,
        addBackupPlanLoading: true,
        addBackupPlanApiResponse: null,
        addBackupPlanError: null,
      };
    case ADD_BACKUP_PLAN_SUCCESS:
      return {
        ...state,
        addBackupPlanLoading: false,
        addBackupPlanApiResponse: action.response,
        addBackupPlanError: null,
        backupPlanInCart: action.planId || state.backupPlanInCart,
        removeLineSuccessUpdateCartFailed: false,
      };
    case ADD_BACKUP_PLAN_FAILURE:
      return {
        ...state,
        addBackupPlanLoading: false,
        addBackupPlanApiResponse: action.response,
        addBackupPlanError: action.error,
      };
    case SET_REMOVE_LINE_SUCCESS_UPDATE_CART_FAILED:
      return {
        ...state,
        removeLineSuccessUpdateCartFailed: Boolean(action.payload),
      };
    case SET_BACKUP_MLP_AUTO_EXPANDED:
      return {
        ...state,
        backupMlpAutoExpanded: true,
      };
    default:
      return state;
  }
};

export default progressivePlansRedesignReducer;